// extracted by mini-css-extract-plugin
export var statItem = "_bv-1";
export var statsRow = "_bv-0";